
nodeChildDirective = ->
    restrict: 'E'
    templateUrl: 'util/tags/nodeChild'
    scope: node: '=node'
    require: '^dybTagPicker'
    link: (scope, element, attrs, tagpicker) ->

        if scope.node.slug? then element.addClass('tag-' + scope.node.slug)

        element.on 'click', ->
            scope.$apply scope.node.browse
            return

        element.on 'mouseenter', ->
            tagpicker.hoverItem(scope.node)
            return

        scope.$on 'tagpicker:activeItemChanged', (event, item) ->
            element.toggleClass('active', item == scope.node)
            return

        return


module.directive 'dybTagpickerNodeChild', nodeChildDirective
